import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import CoevaluationsUserActivity from './CoevaluationUserActivity/CoevaluationUserActivity';
import CoevaluationUserItem from './CoevaluationUserItem/CoevaluationUserItem';
import Loading from 'components/UI/Loading/Loading';

import {
  getListCoevaluationItems,
  getListHomeworks
} from 'store/lesson-actions';

import classes from './CoevaluationsUsers.module.css';
let init = true;

const CoevaluationsUsers = props => {
  const { t } = useTranslation(['lesson']);
  const [page, setPage] = useState(1);
  const [coevalView, setCoevalView] = useState(false);
  const [coevalPDF, setCoevalPDF] = useState(null);
  const [activitiesCoevaluated, setActivitiesCoevaluated] = useState(
    []
  );
  const [idUserActivity, setIdUserActivity] = useState(null);
  const [coevalTitle, setCoevalTitle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const dataLesson = useSelector(state => state.lessonInfo);

  useEffect(() => {
    if (!dataLesson.coevaluationsItems) {
      dispatch(getListCoevaluationItems(props.idLesson));
    }
    dispatch(getListHomeworks(props.idLesson, page, false));
  }, [props.idLesson]);

  useEffect(() => {
    if (!init) {
      dispatch(getListHomeworks(props.idLesson, page, false));
    }
    init = false;
  }, [page]);

  useEffect(() => {
    if (
      dataLesson.coevaluationsItems &&
      dataLesson.homeworksList &&
      isLoading
    ) {
      setIsLoading(false);
    }
  }, [dataLesson.homeworksList, dataLesson.coevaluationsItems]);

  const changePageHandler = changePage => () => {
    setPage(page + changePage);
  };

  const coevalUserHandler = (title, pdf, id) => () => {
    setCoevalView(true);
    setCoevalTitle(title);
    setCoevalPDF(pdf);
    setIdUserActivity(id);
  };

  const closeCoevalUserHandler = () => {
    setCoevalView(false);
  };

  const activitiesCoevaluatedHandler = id => {
    setActivitiesCoevaluated([...activitiesCoevaluated, id]);
  };

  return (
    <>
      {!isLoading && (
        <>
          <div className={classes.activityContainer}>
            {!coevalView && (
              <>
                <aside className={classes.instructionsContainer}>
                  <p className={classes.instructions__title}>
                    {t('list_of_activities')}
                  </p>
                  <div className={classes.changePageContainer}>
                    <Button
                      onClick={changePageHandler(-1)}
                      disabled={page === 1}
                      className={classes.nextBtn}
                    >
                      <ArrowBackIcon />
                    </Button>
                    <Button
                      disabled={dataLesson.homeworksList.length < 5}
                      className={classes.nextBtn}
                      onClick={changePageHandler(1)}
                    >
                      <ArrowForwardIcon />
                    </Button>
                  </div>
                </aside>
                <ul>
                  {dataLesson.homeworksList.map(homework => (
                    <CoevaluationUserItem
                      key={homework.idUserHomework}
                      homeworkData={homework}
                      coevalUser={coevalUserHandler}
                      evals={homework.evals}
                      coevaluation={homework.coevaluation}
                      activitiesCoevaluated={activitiesCoevaluated}
                    />
                  ))}
                </ul>
              </>
            )}
            {coevalView && (
              <CoevaluationsUserActivity
                pdf={coevalPDF}
                title={coevalTitle}
                closeCoevalUser={closeCoevalUserHandler}
                coevaluationsItems={dataLesson.coevaluationsItems}
                idCourse={props.idCourse}
                idLesson={props.idLesson}
                idUserActivity={idUserActivity}
                activitiesCoevaluate={activitiesCoevaluatedHandler}
                changeCoevaluationStatus={
                  props.changeCoevaluationStatus
                }
              />
            )}
          </div>
          <aside className={classes.btnsContainer}>
            <Button
              onClick={props.changeViewHandler}
              className={classes.nextBtn}
            >
              {t('instructions')} <AssignmentIcon />
            </Button>
          </aside>
        </>
      )}
      {isLoading && <Loading />}
    </>
  );
};

CoevaluationsUsers.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  changeViewHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeCoevaluationStatus: PropTypes.func
};

export default CoevaluationsUsers;
